import { GetInvalidPixKeyResponse } from '@interfaces/profile';
import { Typography } from '@vibTheme/components/_base/Typography';
import { Image } from '@vibTheme/components/_base/Image';
import { useEffect, useState } from 'react';
import { VibModal } from '@vibTheme/components/VibModal';
import { Button } from '@vibTheme/components/_base/Button';
import { useRouter } from 'next/router';
import { CommissionRateType } from '@interfaces/_common';

type Props = {
  invalidPixKeys: GetInvalidPixKeyResponse[];
};

export const InvalidPixKeyModal = (props: Props) => {
  const invalidPixKey = props.invalidPixKeys[0];
  if (!invalidPixKey) return null;

  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    setIsOpen(props.invalidPixKeys.length > 0);
  }, [props.invalidPixKeys]);

  const router = useRouter();
  const handleConfirm = () => {
    router.push(resolveButtonLink(invalidPixKey));
    setIsOpen(false);
  };

  return (
    <VibModal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="max-w-[1000px] md:p-main">
        <div className="flex flex-col gap-main md:flex-row md:gap-[5rem] items-center">
          <div className="relative h-[200px] w-[200px] md:h-[298px] md:w-[298px]">
            <Image
              src="/assets/girl-red-alert.svg"
              alt="Garota alerta vermelho :o"
              fill
            />
          </div>

          <div className="md:w-[400px]">
            <Typography component="h1" className="pb-main">
              Identificamos inconsistência na chave Pix cadastrada
            </Typography>
            <Typography className="font-bold">
              Corrija agora para garantir a continuidade dos saques.
            </Typography>
            {resolveMainText(invalidPixKey.commissionRateType)}
          </div>
        </div>

        <div className="pt-2xl text-right">
          <Button id="start-onboarding" onClick={handleConfirm}>
            Ajustar chave Pix
          </Button>
        </div>
      </div>
    </VibModal>
  );
};

const resolveButtonLink = (invalidPixKey: GetInvalidPixKeyResponse) => {
  switch (invalidPixKey.commissionRateType) {
    case CommissionRateType.CO_PRODUCTION:
      return `/products/${invalidPixKey.botConfigProductCode}/coproductions`;

    case CommissionRateType.AFFILIATION:
      return '/affiliation/affiliatedCommunities';

    case CommissionRateType.VIB_ROYALTIES:
    default:
      return '/profile/personalData';
  }
};

const resolveMainText = (crType: CommissionRateType) => {
  switch (crType) {
    case CommissionRateType.CO_PRODUCTION:
      return (
        <Typography>
          Acesse sua comunidade em Comunidades &gt; Coproduções para corrigir a
          chave. Após o ajuste, acesse a tela de Saque, desative o saque
          automático, solicite o saque pelo botão e ative novamente, se desejar.
        </Typography>
      );

    case CommissionRateType.AFFILIATION:
      return (
        <Typography>
          Acesse Afiliações &gt; Comunidades Afiliadas e atualize sua chave Pix.
          Após o ajuste, acesse a tela de Saque, desative o saque automático,
          solicite o saque pelo botão Sacar e ative o saque automático
          novamente, se desejar.
        </Typography>
      );

    case CommissionRateType.VIB_ROYALTIES:
    default:
      return (
        <Typography>
          Acesse seu Perfil e ajuste sua chave Pix diretamente por lá. Após o
          ajuste, acesse a tela de Saque, desative o saque automático, solicite
          o saque pelo botão Sacar e ative o saque automático novamente, se
          desejar.
        </Typography>
      );
  }
};
